<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LocaleSwitcher',
  setup() {
    const currentLocale = document.querySelector('meta[name="current-locale"]')?.getAttribute('content') || 'ru';

    const switchLocale = () => {
      const newLocale = currentLocale === 'en' ? 'ru' : 'en';

      // Remove any existing locale prefix
      let pathWithoutLocale = window.location.pathname.replace(/^\/(en|ru)(?=\/|$)/, '');

      // If we're on locale root (e.g. `/ru`) but the page is a Vue app,
      // preserve the current feature route instead of navigating to `/en` which may be a different root.
      if (pathWithoutLocale === '' || pathWithoutLocale === '/') {
        if (document.getElementById('roster')) {
          pathWithoutLocale = '/rosters/new';
        } else if (document.getElementById('roster-list')) {
          pathWithoutLocale = '/rosters';
        }
      }

      // Full page reload (temporary, until menu is migrated to Vue)
      window.location.pathname = `/${newLocale}${pathWithoutLocale}`;
    };

    return {
      currentLocale,
      switchLocale
    };
  }
});
</script>

<template>
  <button
    class="header-action button button_plain button_icon button_locale"
    @click.stop.prevent="switchLocale"
    :title="currentLocale === 'en' ? 'Switch to Russian' : 'Switch to English'"
  >
    <img :src="`/images/img/${currentLocale === 'en' ? 'ru' : 'en'}2.png`" alt="">
  </button>
</template>

<style scoped>
.header-action {
  font-weight: bold;
  min-width: 40px;
}
.button_locale {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 16px;
  color: #FFF;
}
</style>
